<template>
  <div class="popup-layer" v-if="isShow">
    <div class="popup-box">
      <div class="popup-title">
        预约看房
        <span>
          <img src="http://assets.rurushishi.com/yq-rs-make/t7/icon_close.png" alt @click="close" />
        </span>
      </div>
      <div class="popup-frame">
        <span>您的姓名</span>
        <input type="text" placeholder="请输入" v-model="name" @blur="blurInput" />
      </div>
      <div class="popup-frame">
        <span>手机号码</span>
        <input type="tel" placeholder="请输入" v-model="mobile" @blur="blurInput" />
      </div>
      <div class="popup-frame">
        <span>看房日期</span>
        <!-- <input type="date" v-model="time" :min="minTime"/> -->
        <span @click="selectData">{{time}}</span>
        <div class="selTime">
          <mt-datetime-picker
            ref="picker"
            v-model="time1"
            type="date"
            year-format="{value} 年"
            month-format="{value} 月"
            date-format="{value} 日"
            :start-date="startDate"
            @confirm="handleConfirm"
          ></mt-datetime-picker>
        </div>
      </div>
      <div class="popup-frame" v-if="counselorlist&&counselorlist.length>0">
        <span>选择销售</span>
        <div class="dropDown">
          <Multiselect
            v-model="counselor"
            :options="counselorlist"
            placeholder="请选择销售"
            :searchable="false"
            @input="selectCounselor"
            :allow-empty="false"
            :show-labels="false"
            track-by="counselorname"
            label="counselorname"
          >
            <template slot="singleLabel" slot-scope="{ option }">{{ option.counselorname}}</template>
          </Multiselect>
        </div>
      </div>
      <div class="submit">
        <span @click="subPopup">马上预约</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapState, mapMutations } from "vuex";
import util from "@/utils/utils";
import * as comreq from "@/utils/comreq";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import { MessageBox, DatetimePicker } from "mint-ui";
Vue.component(DatetimePicker.name, DatetimePicker);
let that = null;
export default {
  components: {
    Multiselect
  },
  props: {
    isShow: Boolean,
    salesperson: Array
  },
  data() {
    return {
      psn: this.$route.query.psn,
      pageId: 0,
      projectId: 0,
      mobile: "",
      name: "",
      time1: "",
      time: util.getTime(new Date()),
      flag: false,
      year: "",
      month: "",
      date: "",
      startDate: new Date(),
      refereeopenId: this.$route.query.refereeopenid
        ? this.$route.query.refereeopenid
        : "",
      counselor: [],
      notifyMobile: "",
      counselorname: "",
      counselorlist: this.salesperson,
    };
  },
  watch: {
    // salesperson: {
    //   handler(newValue, oldValue) {
    //     console.log("newValue==999999999999=>", newValue);
    //     console.log("oldValue==999999999999=>",oldValue);
    //     // this.counselorlist = newValue;
    //     // this.getSalerMobileList();
    //   },
    //   deep: true
    // }
  },
  computed: {
    // updateSalespersonList(){
    //   console.log('this.salespersont=====>',this.salesperson)
    //   this.counselorlist=this.salesperson;
    //   return this.getSalerMobileList();
    // },
    ...mapState(["isInMiniProgram", "userInfo", "pageInfo"]),
  },
  methods: {
    selectCounselor: function(data) {
      this.counselor = data;
      this.counselorname = data.counselorname;
      this.notifyMobile = data.mobile;
    },
    selectData() {
      this.$refs.picker.open();
    },
    handleConfirm(value) {
      this.year = value.getFullYear();
      this.month = value.getMonth() + 1;
      this.month <= 9 ? (this.month = "0" + this.month) : this.month;
      this.date = value.getDate();
      this.date <= 9 ? (this.date = "0" + this.date) : this.date;
      return (this.time = this.year + "-" + this.month + "-" + this.date);
    },
    close() {
      this.$emit("close");
    },
    temporaryRepair() {
      let windowFocusHeight = window.innerHeight;
      if (this.windowHeight == windowFocusHeight) {
        return;
      }
      console.log(this.windowHeight + "--" + windowFocusHeight);
      console.log("修复");
      let currentPosition;
      let speed = 1; //页面滚动距离
      currentPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
      currentPosition -= speed;
      window.scrollTo(0, currentPosition); //页面向上滚动
      currentPosition += speed; //speed变量
      window.scrollTo(0, currentPosition); //页面向下滚动
    },
    blurInput() {
      that.temporaryRepair();
    },
    //销售列表
    getSalerMobileList() {
      let _self = this;
      _self.counselorlist = _self.salesperson;
      let tmp = []
      if (_self.counselorlist&&_self.counselorlist.length > 0) {
        _self.counselorlist.forEach((v, i) => {
          if (v.counselorname == null && v.counselornickname != null) {
            v.counselorname = v.counselornickname;
          } 
          tmp.push(v);
        });
        _self.counselorlist = tmp;
        console.log('执行过滤===>',_self.counselorlist, _self.counselorlist.length)
        _self.counselor.push(_self.counselorlist[0]);
        _self.notifyMobile = _self.counselorlist[0].mobile;
      }
    },
    subPopup() {
      let _self = this;
      if (!_self.name) {
        return MessageBox.alert("请填写您的姓名", "提示");
      }
      if (!_self.mobile) {
        return MessageBox.alert("请输入手机号", "提示");
      } else {
        if (!util.isMobile(_self.mobile)) {
          return MessageBox.alert("请填写正确的手机号", "提示");
        }
      }
      if (!_self.time) {
        return MessageBox.alert("请选择看房日期", "提示");
      }
      if (!_self.flag) {
        _self.flag = true;
        comreq
          .subPopupInfo(
            _self.name,
            _self.mobile,
            _self.time,
            _self.projectId,
            _self.pageId,
            _self.psn,
            _self.notifyMobile
          )
          .then(data => {
            if (data.code == 0) {
              _self.flag = false;
              MessageBox.alert("预约成功！", "提示").then(() => {
                _self.$emit("close");
              });
            }
          });
      }
    }
  },
  created() {
    that = this;
  },
  mounted() {
    //获取当前城市
    util.checkMapStateCallback(this, ["pageInfo", "userInfo"]).then(() => {
      this.pageId = this.pageInfo.PageId;
      this.projectId = this.pageInfo.Pid;
      this.mobile = util.getUserMobile(this.userInfo);
      this.counselorlist=this.salesperson;
      this.$nextTick(() => {
        this.getSalerMobileList();
      });
    });
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="css" scoped>
.popup-layer {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 20;
}
.popup-box {
  width: 90%;
  margin-left: 5%;
  margin-top: 3rem;
  border-radius: 0.2rem;
  padding-bottom: 0.2rem;
  box-sizing: border-box;
  background: #fff;
}
.popup-title {
  width: 100%;
  height: 2rem;
  line-height: 2rem;
  font-size: 0.36rem;
  text-align: center;
  position: relative;
}
.popup-title > span {
  position: absolute;
  top: -0.2rem;
  right: 0.2rem;
  width: 0.64rem;
  height: 0.64rem;
}
.popup-title > span > img {
  width: 0.64rem;
  height: 0.64rem;
}
.popup-frame {
  margin: 0.2rem auto;
  height: 0.8rem;
  width: 80%;
  /* border-radius: 0.1rem; */
  background: #ffff;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #ececec;
}
.popup-frame > span {
  line-height: 0.8rem;
  width: 30%;
  display: block;
}
.popup-frame > span:nth-child(2) {
  width: 70%;
  text-align: right;
}
input {
  text-align: right;
  color: #333;
  width: 70%;
  height: 0.8rem;
  line-height: 0.8rem;
  background-color: transparent;
  border: none;
}
.submit {
  width: 100%;
  padding: 0.3rem 0;
}
.submit > span {
  display: block;
  background: #e4813d;
  color: #fff;
  font-size: 0.35rem;
  width: 80%;
  height: 0.88rem;
  line-height: 0.88rem;
  margin: 0 auto;
  text-align: center;
  border-radius: 0.1rem;
}
.dropDown {
  width: 222px;
  height: 40px;
  margin: 0rem auto;
  color: #333;
  background: #fff;
  border-radius: 6px;
  font-size: 12px;
}

.multiselect {
  background: #fff;
  border-radius: 5px;
}

.dropDown >>> .multiselect__tags {
  background: #fff;
  border-radius: 5px;
  height: 40px;
  border: none;
  padding: 10px 40px 0 8px;
}

.dropDown >>> .multiselect__single {
  background: #fff;
  font-size: 12px;
  text-align: right;
}
</style>